import { AlertBannerContext, type AlertBannerState } from '@src/contexts/alert-banner-context'
import { type ReactNode, useCallback, useMemo, useState } from 'react'

const defaultState: AlertBannerState = { message: null, severity: 'error' }

interface Props {
  children: ReactNode
}

const AlertBannerProvider = ({ children }: Props) => {
  const [banner, setBanner] = useState<AlertBannerState>(defaultState)

  const showBanner = useCallback((message: string, severity: AlertBannerState['severity'] = 'error') => {
    setBanner({ message, severity })
  }, [])

  const hideBanner = useCallback(() => {
    setBanner(defaultState)
  }, [])

  const value = useMemo(() => ({ banner, showBanner, hideBanner }), [banner, showBanner, hideBanner])

  return <AlertBannerContext.Provider value={value}>{children}</AlertBannerContext.Provider>
}

export default AlertBannerProvider
